import React, { Component } from "react";
import Form from "./components/Form";
// import 'bootstrap/dist/css/bootstrap.min.css'
import "../src/css/bootstrap.min.css";
import './css/App.css'
import "../src/css/mainStyle.css"

class App extends Component {
  render() {
    return (
      <div>
  <Form/>
      </div>
    );
  }
}

export default App;
